import styled from 'styled-components';

export const DivLgpd = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;

  margin: auto 0 100px;

  p {
    margin: 0;
  }

  @media (min-width: 1920px) {
    margin-bottom: 140px;
  }
`;

export const LgpdStyled = styled.p`
  margin-top: 2rem;
  margin-bottom: 100px;
  width: 100%;
  padding: 0 24px;
  width: 560px;
  text-align: justify;

  font-size: 14px;
  font-weight: 325;
  line-height: 15.6px;
  color: #6c757d;
  letter-spacing: -0.4px;

  @media (max-width: 1366px) {
    width: 95%;
  }
`;
